module.exports = __webpack_public_path__ + "img/scan.805ee967.png";